(function () {
  var STORAGE_KEY = 'pawuni_attribution_v1';
  var COOKIE_KEY = 'pawuni_attribution_v1';
  var FIRST_TOUCH_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var LAST_TOUCH_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var SESSION_TOUCH_TTL_MS = 30 * 60 * 1000;
  var COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60;

  var ATTRIBUTION_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'gclid',
    'fbclid',
    'ttclid',
    'msclkid',
    'gbraid',
    'wbraid',
  ];

  var CLICK_ID_KEYS = ['gclid', 'fbclid', 'ttclid', 'msclkid', 'gbraid', 'wbraid'];

  var state = null;
  var cartSyncInFlight = null;
  var instantClickBound = false;
  var observerBound = false;

  function nowMs() {
    return Date.now();
  }

  function isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  function clone(value) {
    if (value == null) return value;
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (error) {
      return value;
    }
  }

  function safeParseJSON(value) {
    if (!value || typeof value !== 'string') return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function safeJSONStringify(value) {
    try {
      return JSON.stringify(value || {});
    } catch (error) {
      return '{}';
    }
  }

  function sanitizeParamValue(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function normalizeSource(value) {
    var trimmed = sanitizeParamValue(value);
    return trimmed || 'direct';
  }

  function normalizeMedium(value) {
    var trimmed = sanitizeParamValue(value);
    return trimmed || '(none)';
  }

  function getLandingPage() {
    return ''.concat(window.location.pathname || '/', window.location.search || '', window.location.hash || '');
  }

  function getReferrer() {
    return sanitizeParamValue(document.referrer || '');
  }

  function getStorageItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStorageItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function readCookie(name) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    for (var index = 0; index < cookies.length; index += 1) {
      var parts = cookies[index].split('=');
      var cookieName = parts.shift();
      if (cookieName !== name) continue;
      return decodeURIComponent(parts.join('=') || '');
    }
    return null;
  }

  function writeCookie(name, value, maxAgeSeconds) {
    var encodedValue = encodeURIComponent(value);
    var cookie = ''.concat(name, '=').concat(encodedValue, '; path=/; max-age=').concat(maxAgeSeconds, '; SameSite=Lax');
    if (window.location.protocol === 'https:') {
      cookie += '; Secure';
    }
    document.cookie = cookie;
  }

  function isExpired(touch, ttlMs) {
    if (!touch || !touch.ts) return true;
    return nowMs() - Number(touch.ts) > ttlMs;
  }

  function readIncomingQueryParams() {
    var values = {};
    var hasAny = false;
    var search = window.location.search || '';
    var params = null;

    try {
      params = new URLSearchParams(search);
    } catch (error) {
      params = null;
    }

    for (var index = 0; index < ATTRIBUTION_KEYS.length; index += 1) {
      var key = ATTRIBUTION_KEYS[index];
      var value = '';

      if (params) {
        value = sanitizeParamValue(params.get(key));
      } else {
        var pattern = new RegExp('(?:\\?|&)'.concat(key, '=([^&]*)'), 'i');
        var matched = search.match(pattern);
        value = sanitizeParamValue(matched && matched[1] ? decodeURIComponent(matched[1]) : '');
      }

      if (!value) continue;
      values[key] = value;
      hasAny = true;
    }

    return { hasAny: hasAny, values: values };
  }

  function toClickIds(values) {
    var clickIds = {};

    for (var index = 0; index < CLICK_ID_KEYS.length; index += 1) {
      var key = CLICK_ID_KEYS[index];
      var value = sanitizeParamValue(values[key]);
      if (!value) continue;
      clickIds[key] = value;
    }

    return clickIds;
  }

  function buildTouch(values) {
    var cleanValues = isObject(values) ? values : {};

    return {
      ts: nowMs(),
      landing_page: getLandingPage(),
      referrer: getReferrer(),
      utm_source: normalizeSource(cleanValues.utm_source),
      utm_medium: normalizeMedium(cleanValues.utm_medium),
      utm_campaign: sanitizeParamValue(cleanValues.utm_campaign),
      utm_term: sanitizeParamValue(cleanValues.utm_term),
      utm_content: sanitizeParamValue(cleanValues.utm_content),
      utm_id: sanitizeParamValue(cleanValues.utm_id),
      click_ids: toClickIds(cleanValues),
    };
  }

  function buildSessionTouch(fromTouch) {
    var sourceTouch = isObject(fromTouch) ? fromTouch : {};

    return {
      ts: nowMs(),
      landing_page: getLandingPage(),
      utm_source: normalizeSource(sourceTouch.utm_source),
      utm_medium: normalizeMedium(sourceTouch.utm_medium),
      utm_campaign: sanitizeParamValue(sourceTouch.utm_campaign),
      utm_term: sanitizeParamValue(sourceTouch.utm_term),
      utm_content: sanitizeParamValue(sourceTouch.utm_content),
      utm_id: sanitizeParamValue(sourceTouch.utm_id),
      click_ids: toClickIds(sourceTouch.click_ids || sourceTouch),
    };
  }

  function normalizeStateShape(raw) {
    var normalized = isObject(raw) ? raw : {};
    return {
      first_touch: isObject(normalized.first_touch) ? normalized.first_touch : null,
      last_touch: isObject(normalized.last_touch) ? normalized.last_touch : null,
      session_touch: isObject(normalized.session_touch) ? normalized.session_touch : null,
    };
  }

  function loadState() {
    var fromStorage = safeParseJSON(getStorageItem(STORAGE_KEY));
    if (isObject(fromStorage)) return normalizeStateShape(fromStorage);

    var fromCookie = safeParseJSON(readCookie(COOKIE_KEY));
    return normalizeStateShape(fromCookie);
  }

  function saveState(nextState) {
    var serialized = safeJSONStringify(nextState);
    setStorageItem(STORAGE_KEY, serialized);
    writeCookie(COOKIE_KEY, serialized, COOKIE_MAX_AGE_SECONDS);
  }

  function pruneState(rawState) {
    var nextState = normalizeStateShape(rawState);

    if (isExpired(nextState.first_touch, FIRST_TOUCH_TTL_MS)) nextState.first_touch = null;
    if (isExpired(nextState.last_touch, LAST_TOUCH_TTL_MS)) nextState.last_touch = null;
    if (isExpired(nextState.session_touch, SESSION_TOUCH_TTL_MS)) nextState.session_touch = null;

    return nextState;
  }

  function dispatchAttributionReady(payload) {
    var detail = clone(payload);
    var event = null;

    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent('pawuni:attribution_ready', {
        detail: detail,
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('pawuni:attribution_ready', true, true, detail);
    }

    document.dispatchEvent(event);
  }

  function getState() {
    return clone(state);
  }

  function toCartAttributes() {
    var current = getState() || {};
    var lastTouch = current.last_touch || {};
    var clickIds = isObject(lastTouch.click_ids) ? lastTouch.click_ids : {};

    return {
      utm_source: normalizeSource(lastTouch.utm_source),
      utm_medium: normalizeMedium(lastTouch.utm_medium),
      utm_campaign: sanitizeParamValue(lastTouch.utm_campaign),
      utm_term: sanitizeParamValue(lastTouch.utm_term),
      utm_content: sanitizeParamValue(lastTouch.utm_content),
      utm_id: sanitizeParamValue(lastTouch.utm_id),
      gclid: sanitizeParamValue(clickIds.gclid),
      fbclid: sanitizeParamValue(clickIds.fbclid),
      ttclid: sanitizeParamValue(clickIds.ttclid),
      msclkid: sanitizeParamValue(clickIds.msclkid),
      gbraid: sanitizeParamValue(clickIds.gbraid),
      wbraid: sanitizeParamValue(clickIds.wbraid),
      first_touch_json: safeJSONStringify(current.first_touch || {}),
      last_touch_json: safeJSONStringify(current.last_touch || {}),
    };
  }

  function toLeadFields() {
    var current = getState() || {};
    var cartAttributes = toCartAttributes();

    return {
      utm_source: cartAttributes.utm_source,
      utm_medium: cartAttributes.utm_medium,
      utm_campaign: cartAttributes.utm_campaign,
      utm_term: cartAttributes.utm_term,
      utm_content: cartAttributes.utm_content,
      utm_id: cartAttributes.utm_id,
      gclid: cartAttributes.gclid,
      fbclid: cartAttributes.fbclid,
      ttclid: cartAttributes.ttclid,
      msclkid: cartAttributes.msclkid,
      gbraid: cartAttributes.gbraid,
      wbraid: cartAttributes.wbraid,
      first_touch_json: cartAttributes.first_touch_json,
      last_touch_json: cartAttributes.last_touch_json,
      session_touch_json: safeJSONStringify(current.session_touch || {}),
      attribution_json: safeJSONStringify(current),
    };
  }

  function enrichPayload(payload) {
    var base = isObject(payload) ? clone(payload) : {};
    base.attribution = getState();
    return base;
  }

  function updateGlobalState(nextState) {
    state = clone(nextState);
    window.__ATTRIBUTION__ = getState();
    saveState(state);
    dispatchAttributionReady(state);
  }

  function refreshAttributionFromLocation() {
    var nextState = pruneState(loadState());
    var incoming = readIncomingQueryParams();

    if (incoming.hasAny) {
      nextState.last_touch = buildTouch(incoming.values);
      if (!nextState.first_touch) {
        nextState.first_touch = clone(nextState.last_touch);
      }
    } else {
      if (!nextState.last_touch) {
        nextState.last_touch = buildTouch({});
      }
      if (!nextState.first_touch) {
        nextState.first_touch = clone(nextState.last_touch);
      }
    }

    if (incoming.hasAny || !nextState.session_touch) {
      nextState.session_touch = buildSessionTouch(nextState.last_touch);
    } else {
      nextState.session_touch = buildSessionTouch(nextState.session_touch);
    }

    updateGlobalState(nextState);
    return getState();
  }

  function mapByGroup(group) {
    if (group === 'cart') return toCartAttributes();
    return toLeadFields();
  }

  function populateAttributionFields(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var inputs = scope.querySelectorAll('[data-attribution-field][data-attribution-key]');
    if (!inputs || !inputs.length) return;

    inputs.forEach(function (input) {
      if (!input || input.tagName !== 'INPUT') return;
      var key = input.getAttribute('data-attribution-key');
      if (!key) return;

      var group = input.getAttribute('data-attribution-group') || 'lead';
      var values = mapByGroup(group);

      if (!Object.prototype.hasOwnProperty.call(values, key)) return;
      input.value = sanitizeParamValue(values[key]);
    });
  }

  function ensureCartFormInputs(form, cartAttributes) {
    if (!form || typeof form.querySelector !== 'function') return;

    Object.keys(cartAttributes).forEach(function (key) {
      var inputName = 'attributes['.concat(key, ']');
      var selector = 'input[name="'.concat(inputName, '"]');
      var input = form.querySelector(selector);

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = inputName;
        input.setAttribute('data-attribution-field', '');
        input.setAttribute('data-attribution-group', 'cart');
        input.setAttribute('data-attribution-key', key);
        form.appendChild(input);
      }

      input.value = sanitizeParamValue(cartAttributes[key]);
    });
  }

  function isCartFormSynced(form, cartAttributes) {
    if (!form || typeof form.querySelector !== 'function') return false;

    return Object.keys(cartAttributes).every(function (key) {
      var inputName = 'attributes['.concat(key, ']');
      var selector = 'input[name="'.concat(inputName, '"]');
      var input = form.querySelector(selector);

      if (!input) return false;
      return sanitizeParamValue(input.value) === sanitizeParamValue(cartAttributes[key]);
    });
  }

  function postCartAttributes(cartAttributes) {
    if (typeof window.fetch !== 'function') {
      return Promise.resolve({});
    }

    var body = new URLSearchParams();
    Object.keys(cartAttributes).forEach(function (key) {
      body.set('attributes['.concat(key, ']'), sanitizeParamValue(cartAttributes[key]));
    });

    return window
      .fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: body.toString(),
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to sync cart attribution');
        }
        return response.json().catch(function () {
          return {};
        });
      });
  }

  function syncCartAttributesBeforeCheckout(form) {
    var cartAttributes = toCartAttributes();
    var requiresSync = !isCartFormSynced(form, cartAttributes);
    ensureCartFormInputs(form, cartAttributes);
    populateAttributionFields(form);

    if (!requiresSync) {
      return Promise.resolve(cartAttributes);
    }

    if (cartSyncInFlight) {
      return cartSyncInFlight;
    }

    cartSyncInFlight = postCartAttributes(cartAttributes)
      .then(function () {
        return cartAttributes;
      })
      .finally(function () {
        cartSyncInFlight = null;
      });

    return cartSyncInFlight;
  }

  function bindSubmitAutofill() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;
        populateAttributionFields(form);
      },
      true,
    );
  }

  function isCheckoutButton(button) {
    if (!button || button.tagName !== 'BUTTON') return false;
    if (button.getAttribute('name') === 'checkout') return true;
    if (button.hasAttribute('data-cart-checkout-button')) return true;
    return false;
  }

  function bindCheckoutSync() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== 'function') return;

        var button = target.closest('[data-cart-checkout-button], [data-minicart-checkout-button]');
        if (!isCheckoutButton(button)) return;
        if (button.dataset.pawuniAttributionSyncing === '1') return;

        var form = button.closest('form');
        if (!form) return;

        var tosCheckbox = form.querySelector('.tos_agree');
        if (tosCheckbox && !tosCheckbox.checked) return;

        var cartAttributes = toCartAttributes();
        var requiresSync = !isCartFormSynced(form, cartAttributes);
        if (!requiresSync) {
          ensureCartFormInputs(form, cartAttributes);
          populateAttributionFields(form);
          return;
        }

        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        button.dataset.pawuniAttributionSyncing = '1';
        button.disabled = true;

        syncCartAttributesBeforeCheckout(form)
          .catch(function () {
            return null;
          })
          .finally(function () {
            button.dataset.pawuniAttributionSyncing = '0';
            button.disabled = false;
            populateAttributionFields(form);

            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(button);
            } else {
              form.submit();
            }
          });
      },
      true,
    );
  }

  function bindAttributionObserver() {
    if (observerBound || !window.MutationObserver) return;
    observerBound = true;

    var pending = false;
    var runPopulate = function () {
      pending = false;
      populateAttributionFields(document);
    };

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes || []).some(function (node) {
          if (!(node instanceof Element)) return false;
          if (node.matches('[data-attribution-field]')) return true;
          return Boolean(node.querySelector('[data-attribution-field]'));
        });
      });

      if (!shouldRun || pending) return;
      pending = true;
      window.requestAnimationFrame(runPopulate);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function bindInstantClickRefresh() {
    if (instantClickBound) return;
    if (!window.InstantClick || typeof window.InstantClick.on !== 'function') return;

    instantClickBound = true;
    window.InstantClick.on('change', function () {
      refreshAttributionFromLocation();
      populateAttributionFields(document);
    });
  }

  function bootstrapDomBindings() {
    populateAttributionFields(document);
    bindSubmitAutofill();
    bindCheckoutSync();
    bindAttributionObserver();
    bindInstantClickRefresh();
  }

  refreshAttributionFromLocation();

  window.PawuniAttribution = {
    get: getState,
    refresh: refreshAttributionFromLocation,
    toCartAttributes: toCartAttributes,
    toLeadFields: toLeadFields,
    enrichPayload: enrichPayload,
    populateFields: populateAttributionFields,
    syncCartAttributesBeforeCheckout: syncCartAttributesBeforeCheckout,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrapDomBindings);
  } else {
    bootstrapDomBindings();
  }
})();
